module.exports = __webpack_public_path__ + "img/under-maintenance-dark.c391f09f.svg";